import { render, staticRenderFns } from "./d-new-follow-activity.vue?vue&type=template&id=7d9802bf&"
import script from "./d-new-follow-activity.vue?vue&type=script&lang=js&"
export * from "./d-new-follow-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports